import api from "@/api.js";
export default {
    // 搜索
    onSearch({ commit, state }, key) {
        return new Promise((resolve, reject)=>{
            // console.log(key,'key');
            // console.log(state,'state');
            api.get('/developers/build/list',{
                search:key
               }).then((res)=>{
                  if(res.code==200){
                    state.searchList=res.result;
                  }
                  resolve();
              });
            
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js